/**
 * Consists of commands and event names which results in the push protocol.
 * @enum {string} PUSH_PROTOCOL
 * @readonly
 */
export const PUSH_PROTOCOL = {
    /** Command for sending the scheduler configuration from the client to the server. */
    COMMAND_CONFIG: 'push::config',
    /** Command from client requesting the server to start sending data. */
    COMMAND_START: 'push::start',
    /** Command from client requesting the server to stop sending data. */
    COMMAND_STOP: 'push::stop',
    /** Event with data sent by the server (triggers 'fetch' action on store). */
    EVENT_DATA: 'push::data',
    /** Event with data sent by the server (triggers 'patch' action on store). */
    EVENT_PATCH: 'push::patch'
}
